import styled from 'styled-components';
import ChartStandOutline from '@simplywallst/ui-core/icons/ChartStandOutline';

export const ChartStandIcon = styled(ChartStandOutline)`
  fill: ${({ theme }) => theme.color.white};
  opacity: 0.3;
  width: ${({ theme }) => `${theme.x8spacePx}px`};
  height: ${({ theme }) => `${theme.x8spacePx}px`};
  margin-bottom: ${({ theme }) => `${theme.x1spacePx}px`};
`;

export const Placeholder = styled('section')`
  text-align: center;
  padding: ${({ theme }) => `${theme.x4spacePx}px`};
  border-radius: ${({ theme }) => `${theme.x1spacePx}px`};
  background: ${({ theme }) => theme.color.noir};
  margin-bottom: ${({ theme }) => `${theme.x2spacePx}px`};
`;

export const Title = styled('h2')`
  ${({ theme }) => theme.typography.xLargeStrong}
  margin: ${({ theme }) => `0 0 ${theme.x1spacePx}px 0`};
`;

export const Intro = styled('p')`
  ${({ theme }) => theme.typography.xSmall}
  opacity: 0.7;
  margin: ${({ theme }) => `0 0 ${theme.x3spacePx}px 0`};
`;
